module.exports = __webpack_public_path__ + "img/TCC-L9-Pagina6 A.228e2550.png";